import axiosInstance from "../../lib/axiosInstance";
import { getErrorMessage } from "../../utils/errorUtils";
import { toast } from "react-toastify";
import {
  setLoadingDocumentHeaders,
  setDocumentHeaders,
  setErrorLoadingDocumentHeaders,
  setLoadingDocumentHeaderUpdate,
  updateDocumentHeaderSuccess,
  setErrorUpdatingDocumentHeader,
  setServerResponseStatus,
} from "../slices/documentHeader";

export const getDocumentHeaders = () => async (dispatch) => {
  dispatch(setLoadingDocumentHeaders());
  try {
    const { data } = await axiosInstance.get("/document-headers", {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setDocumentHeaders(data.data)); // No pagination here
    }
  } catch (error) {
    dispatch(setErrorLoadingDocumentHeaders(getErrorMessage(error)));
  }
};

export const updateDocumentHeader =
  ({ id, values }) =>
  async (dispatch) => {
    dispatch(setLoadingDocumentHeaderUpdate());
    try {
      const { data } = await axiosInstance.put(
        `/document-headers/${id}`,
        values,
        {
          headers: { requiresAuth: true },
        },
      );

      if (data.status === "SUCCESS") {
        toast.success(data.message || "Document header updated successfully!");
        dispatch(updateDocumentHeaderSuccess(data.data));
        dispatch(setServerResponseStatus({ operation: "update", status: 200 }));
      }
    } catch (error) {
      const msg = getErrorMessage(error);
      toast.error(msg);
      dispatch(setErrorUpdatingDocumentHeader(msg));
    }
  };

export const resetDocumentHeaderServerStatus = () => (dispatch) => {
  dispatch(setServerResponseStatus(null));
};
